import { Typography } from '@jouzen/ecom-components/v3/Typography';
import type { RichTranslationValues } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

interface MembershipAccordionContentProps {
  readonly contentMsgKey: MessageKey;
  readonly dataCy?: string;
  readonly values?: RichTranslationValues;
}

const MembershipAccordionContent = ({
  contentMsgKey,
  values,
  dataCy,
}: MembershipAccordionContentProps) => {
  return (
    <Typography color="dark" className="text-sm lg:text-xl" data-cy={dataCy}>
      <RichText messageKey={contentMsgKey} tValues={values} />
    </Typography>
  );
};
export default MembershipAccordionContent;
